import {ChangeDetectionStrategy, Component, ElementRef, Inject, ViewChild} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {OneDriveFil, OneDriveFilvelgerGui} from "./OneDriveFilvelgerGui";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle} from "@angular/material/dialog";
import {TranslateModule} from "@ngx-translate/core";
import {AgendaelementId, ImporterMicrosoftOneDriveDokumentISakSpesifikasjon, MøteId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {OneDriveOpplasting} from "./OneDriveOpplasting";
import {OpplastingsstatusSkyfilerKomponent} from "web-ng2/delt/komponenter/filvelger-skytjenester/komponenter/opplastingsstatus-skyfiler/opplastingsstatus-skyfiler";
import {EksisterendeDokumentFunksjon, ValgteSkyfiler} from "web-ng2/delt/komponenter/filvelger-skytjenester/SkyfilOpplasting";
import {BasisFilvelgerDialog, DialogParametre} from "web-ng2/delt/komponenter/filvelger-skytjenester/modale/BasisFilvelgerDialog";

const debug = initDebugger('OnedriveFilvelgerDialogKomponent');

/** Modal dialog som lar bruker velge filer fra OneDrive og registrere disse som saksdokumenter under angitt sak */
@Component({
    selector: 'onedrive-filvelger-dialog',
    templateUrl: 'onedrive-filvelger-dialog.html',
    styleUrl: 'onedrive-filvelger-dialog.scss',
    imports: [
        MatDialogTitle,
        TranslateModule,
        OpplastingsstatusSkyfilerKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnedriveFilvelgerDialogKomponent extends BasisFilvelgerDialog<OneDriveFil, ImporterMicrosoftOneDriveDokumentISakSpesifikasjon> {

    static vis(dialog: MatDialog, sakId: AgendaelementId, møteId: MøteId, eksisterendeDokument: EksisterendeDokumentFunksjon): MatDialogRef<OnedriveFilvelgerDialogKomponent, void> {
        return dialog.open(OnedriveFilvelgerDialogKomponent, {data: {sakId, møteId, eksisterendeDokument} as DialogParametre, width: '80%', height: '600px', panelClass: 'onedrive-filepicker-dialog'});
    }

    @ViewChild('pickerKontainer') private pickerKontainer!: ElementRef<HTMLElement>;

    constructor(@Inject(MAT_DIALOG_DATA) parametre: DialogParametre,
                dialogRef: MatDialogRef<OnedriveFilvelgerDialogKomponent>,
                private oneDriveFilvelgerGui: OneDriveFilvelgerGui,
                oneDriveOpplasting: OneDriveOpplasting) {
        super(parametre, dialogRef, oneDriveOpplasting, debug);
    }

    logut() {
        this.oneDriveFilvelgerGui.logut();
    }

    // BasisFilvelgerDialog implementasjon

    protected velgFiler(): Promise<ValgteSkyfiler<OneDriveFil> | null> {
        return this.oneDriveFilvelgerGui.visPickerGUI(() => this.pickerIframe());
    }

    // private hjelpemetoder

    private async pickerIframe(): Promise<Window> {
        // initielt vises modal med display:none siden OneDriveFilvelgerGui først vil vise en popup med innloggingsdialog
        // (dersom bruker ikke allerede er logget inn i Microsoft), først når pickerIframe() kalles
        // (når OneDriveFilvelgerGui skal til å initialisere FilePicker GUIen) viser vi modalen
        this.dialogRef.addPanelClass('vis');

        //opprett en iframe og legg denne til kontaineren
        var iframe = document.createElement('iframe');
        iframe.src = '';
        this.pickerKontainer.nativeElement.appendChild(iframe);
        return iframe.contentWindow!;
    }

}
